'use client';

import Image from '@/grandus-lib/components-atomic/image/Image';
import map from 'lodash/map';
import { useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { getImageUrl } from '@/grandus-lib/utils';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const Gallery = ({ images }) => {
  const [index, setIndex] = useState(-1);


  const handlePhotoClick = (index) => (e) => {
    e.preventDefault();

    setIndex(index);
  }

  const imageSecurity = {
    imageProps: {
      onContextMenu: e => e.preventDefault(),
      draggable: false,
    },
  };

  const photos = map(images, (photo, index) => {
    return {
      src: getImageUrl(photo, '1920x1080__fit_size', 'webp'),
      key: index,
      width: 1920,
      height: 1080,
    };
  });

  return (
    <>
      <div className={'grid grid-cols-2 gap-2 lg:grid-cols-4 group'}>
          {map(images, (photo, i) => {
            return (
              <div className='col-span-1 overflow-hidden' key={`desktop-gallery-slider-${i}`}>
                <a onClick={handlePhotoClick(i)} className="w-full shrink-0 cursor-pointer hover:[&>img]:scale-105 [&>img]:transition-transform [&>img]:duration-500" key={`gallery-item-${photo?.id}-${index}`}>
                  <Image
                    photo={photo}
                    alt={photo?.description || ''}
                    useNextImage={true}
                    type={'jpg'}
                    size={'400x350__cropped@2x'}
                    usePlaceholder={true}
                    className="w-full h-auto"
                    {...imageSecurity}
                  />
                </a>
              </div>
            );
          })}
      </div>

      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={photos}
        on={{
          view: () => {
            // prevent context menu on lightbox container
            const lightboxEl = document.querySelector('.yarl__portal');
            if (lightboxEl) {
              lightboxEl.addEventListener('contextmenu', e => e.preventDefault());
            }
          },
        }}
        styles={{
          container: {
            background:
              'linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.85) 30%, rgba(0,0,0,0.75) 100%)',
            backdropFilter: 'blur(10px)',
          },
        }}
      />
    </>
  );
};

export default Gallery;
